import React from 'react';
import { ExternalLink } from 'lucide-react';
import { distributor } from '../../data/mock';
import { trackCTAClick } from '../../utils/analytics';

// Persistent distributor banner shown site-wide (FMS Distributor Zone: navy + orange)
const DistributorBanner = () => {
  const handleClick = () => {
    trackCTAClick('fms', 'DistributorBanner');
  };

  return (
    <div
      className="distributor-banner fixed top-0 left-0 right-0 z-[1001] py-2 px-4 overflow-hidden"
      data-testid="distributor-banner"
    >
      <div className="relative max-w-7xl mx-auto flex items-center justify-center gap-2 text-center text-[11px] sm:text-sm whitespace-nowrap overflow-hidden px-2">
        <span className="text-[#F08A24] font-semibold uppercase shrink-0">
          <span className="md:hidden">Exclusive PH Distributor:</span>
          <span className="hidden md:inline">Exclusive distributor in the Philippines:</span>
        </span>
        <span className="hidden md:inline text-white/90 font-mono truncate">{distributor.name}</span>
        <span className="md:hidden text-white/90 font-mono shrink-0">FMSInc.</span>
        <a
          href={distributor.website}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          data-testid="distributor-banner-link"
          className="text-[#F08A24] hover:text-white transition-colors flex items-center gap-1 font-semibold shrink-0"
        >
          <span className="hidden sm:inline">{distributor.displayUrl}</span>
          <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
};

export default DistributorBanner;
